var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCommentsCircleBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("path", {
  d: "M16.38 8.44a.11.11 0 0 1 .12.1v5.6a.12.12 0 0 1-.12.1h-4.06l-.4.29L10 16v-1.76H7.62a.12.12 0 0 1-.12-.1v-5.6a.11.11 0 0 1 .12-.1zm0-1.5H7.62A1.61 1.61 0 0 0 6 8.54v5.6a1.62 1.62 0 0 0 1.62 1.6h.88v3.2l4.32-3.2h3.56a1.62 1.62 0 0 0 1.62-1.6v-5.6a1.61 1.61 0 0 0-1.62-1.6",
  style: {
    fill: "#343e3e"
  }
}));
export default SvgCommentsCircleBlack;